export enum Command {
    UpdatePerformanceDataInterval = 'updatePerformanceDataInterval',
    UpdatePowerStatusInterval = 'updatePowerStatusInterval',
    UpdateSerialNumber = 'updateSerialNumber',
    UpdateModelNumber = 'updateModelNumber',
    Identify = 'identify',
    IdentifyStop = 'identifyStop',
    UpdateLocale = 'updateLocale',
};


export const CommandList: Command[] = [
    Command.UpdatePerformanceDataInterval,
    Command.UpdatePowerStatusInterval,
    Command.UpdateSerialNumber,
    Command.UpdateModelNumber,
    Command.Identify,
    Command.IdentifyStop,
    Command.UpdateLocale,
];